import { MenuItem } from '@chakra-ui/react';
import { AxiosError } from 'axios';
import { useGlobalContext } from 'GlobalContext';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { reactivateContract } from 'services/contract';
import { Mixpanel } from 'services/mixpanel';
import { AlertButtonOutput } from 'shared/components/Alert';
import { Contract } from 'shared/models/contract';
import { useFinancialContext } from '../../FinancialContext';
import DisableContractModal, {
  ModalOutputValue,
} from '../modals/DisableContractModal';
interface DeativateContractMenuItemProps {
  contract: Contract;
  icon?: JSX.Element;
  shouldOpenContract?: boolean;
}
const ToggleContractStatusMenuItem = ({
  contract,
  icon,
  shouldOpenContract = true,
}: DeativateContractMenuItemProps) => {
  const enableAlertButtonText = 'Sim, quero desativar o contrato';
  const { alertController } = useGlobalContext();
  const { reloadContracts } = useFinancialContext();
  const [disableContractModalOpen, setDisableContractModalOpen] =
    useState(false);
  const changeAlertButtonState = (
    stt: boolean,
    alertButtonOutput: AlertButtonOutput,
  ) => {
    alertButtonOutput.clickedButton.disabled = stt;
    alertButtonOutput.clickedButton.text = stt
      ? 'Desativando...'
      : enableAlertButtonText;
    alertButtonOutput.atualizeStateButton(alertButtonOutput.clickedButton);
  };
  const enableContractRequest = (alertButtonOutput: AlertButtonOutput) => {
    changeAlertButtonState(true, alertButtonOutput);
    Mixpanel.track('customers-financial-deleted-contract');
    reactivateContract(contract.id as number)
      .then(() => {
        changeAlertButtonState(false, alertButtonOutput);
        alertButtonOutput.close();
        toast.success('Contrato reativado com sucesso');
        reloadContracts(false, shouldOpenContract ? contract : undefined);
      })
      .catch((e: AxiosError) => {
        changeAlertButtonState(false, alertButtonOutput);
        alertButtonOutput.close();
        toast.error('Não foi possível reativar o contrato');
        console.error(
          'Não foi possível reativar o contrato',
          e?.response?.data
            ? JSON.stringify(e?.response?.data, null, 2)
            : JSON.stringify(e?.response, null, 2),
        );
      });
  };
  const confirmAction = (
    onConfirm: (alertButtonOutput: AlertButtonOutput) => void,
  ) => {
    alertController?.showAlert({
      title: 'Você tem certeza que quer reativar o contrato?',
      message: 'Essa ação tem os seguintes impactos:',
      itensList: [
        'Reativa o contrato.',
        'Reativa os planos e serviços do contrato.',
        'Reativa as cobranças com vencimento futuro.',
      ],
      buttons: [
        {
          text: 'Sim, quero reativar o contrato',
          variant: 'emphasisSuccess',
          preventClose: true,
          onClick: (alertButtonOutput) => onConfirm(alertButtonOutput),
        },
        {
          text: 'Cancelar',
          variant: 'regular',
        },
      ],
    });
  };
  const openDisableContractModal = () => setDisableContractModalOpen(true);
  const closeDisableContractModal = (modalOutputValue?: ModalOutputValue) => {
    if (modalOutputValue) {
      if (modalOutputValue.stt) {
        toast.success(modalOutputValue.msg);
        reloadContracts(false, shouldOpenContract ? contract : undefined);
      } else {
        toast.error(modalOutputValue.msg);
      }
    }
    setDisableContractModalOpen(false);
  };
  const handleToggleEnableContract = () => {
    if (contract.status === 0) {
      confirmAction(enableContractRequest);
    } else {
      openDisableContractModal();
    }
  };
  return (
    <>
      <MenuItem gap="2" onClick={handleToggleEnableContract}>
        {icon}
        {contract.status !== 0 ? 'Desativar contrato' : 'Reativar contrato'}
      </MenuItem>
      {disableContractModalOpen && (
        <DisableContractModal
          isOpen={disableContractModalOpen}
          onClose={closeDisableContractModal}
          contract={contract}
        />
      )}
    </>
  );
};
export default ToggleContractStatusMenuItem;
